"use client";

import { useEffect } from "react";

/**
 * Registers the service worker on mount.
 * Kept as a standalone client component so it doesn't bloat the server-rendered layout.
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("[sw] Registration failed:", err);
      });
    }
  }, []);

  return null;
}
